import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, XCircle } from 'lucide-react';
export function Audience() {
  return <Section background="white" data-id="element-19">
      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-20">
        <div className="bg-[#E6F4F4] p-8 rounded-3xl" data-id="element-21">
          <h3 className="text-xl font-bold text-[#4AAAA5] mb-6 flex items-center" data-id="element-22">
            <CheckCircle2 className="mr-2" data-id="element-23" /> Es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-24">
            <li className="flex items-start" data-id="element-25">
              <span className="mr-2 mt-1.5 w-1.5 h-1.5 bg-[#4AAAA5] rounded-full" data-id="element-26"></span>
              <span className="text-gray-700" data-id="element-27">
                Tu casa se vuelve un campo de batalla por cosas pequeñas como
                los zapatos.
              </span>
            </li>
            <li className="flex items-start" data-id="element-28">
              <span className="mr-2 mt-1.5 w-1.5 h-1.5 bg-[#4AAAA5] rounded-full" data-id="element-29"></span>
              <span className="text-gray-700" data-id="element-30">
                Quieres límites firmes pero no quieres vivir gritando.
              </span>
            </li>
            <li className="flex items-start" data-id="element-31">
              <span className="mr-2 mt-1.5 w-1.5 h-1.5 bg-[#4AAAA5] rounded-full" data-id="element-32"></span>
              <span className="text-gray-700" data-id="element-33">
                Buscas una herramienta práctica y visual, no más teoría de
                crianza.
              </span>
            </li>
          </ul>
        </div>

        <div className="bg-[#FFF5F0] p-8 rounded-3xl" data-id="element-34">
          <h3 className="text-xl font-bold text-[#E8845F] mb-6 flex items-center" data-id="element-35">
            <XCircle className="mr-2" data-id="element-36" /> No es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-37">
            <li className="flex items-start" data-id="element-38">
              <span className="mr-2 mt-1.5 w-1.5 h-1.5 bg-[#E8845F] rounded-full" data-id="element-39"></span>
              <span className="text-gray-700" data-id="element-40">
                Buscas que tu hijo "obedezca perfecto" sin que tú cambies nada.
              </span>
            </li>
            <li className="flex items-start" data-id="element-41">
              <span className="mr-2 mt-1.5 w-1.5 h-1.5 bg-[#E8845F] rounded-full" data-id="element-42"></span>
              <span className="text-gray-700" data-id="element-43">
                No estás dispuesto a sostener el sistema por al menos 7-14 días.
              </span>
            </li>
            <li className="flex items-start" data-id="element-44">
              <span className="mr-2 mt-1.5 w-1.5 h-1.5 bg-[#E8845F] rounded-full" data-id="element-45"></span>
              <span className="text-gray-700" data-id="element-46">
                Esperas una solución mágica que no requiera tu guía inicial.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </Section>;
}